import React from 'react';
import styles from './styles.scss';

const RadioboxDetail = (props) => {
    return (
        <div className={[styles.radioBoxWrap, props.isProduct ? styles.product : undefined].join(" ")} style={props.styles}>
            <div className={styles.radioWrap} style={props.styles}>
                <input type="radio" name={props.name} id={props.id1} value={props.value1}
                    onClick={() => props.onChange(props.value1)}  />
                <label htmlFor={props.id1}>{props.lblNm1}</ label>
            </div>
            <div className={styles.radioWrap}>
                <input type="radio" name={props.name} id={props.id2} value={props.value2}
                    onClick={() => props.onChange(props.value2)} defaultChecked />
                <label htmlFor={props.id2}>{props.lblNm2}</label>
            </div>
        </div>
    )
};

export default RadioboxDetail;


